<script>
  import Wave from './wave.svelte';
  import BottomActions from './bottomActions.svelte';
  import PermitMic from './permitMic.svelte';
  import { getTimerLabel } from './utils/timer';
  import { RecordingStatus, PreviewStatus } from './utils/enum';

  let currentRecordingStatus = RecordingStatus.BEFORE_RECORDING;
  let currentPreviewStatus = PreviewStatus.PAUSE;
  let rawBlob = null;
  // mypages/recs/show.html.haml内のtextareaのidを指定
  let textArea = document.getElementById('voiceData');
  let playLabel = '00:00';

  const startRecording = () => currentRecordingStatus = RecordingStatus.RECORDING;
  const stopRecording = () => currentRecordingStatus = RecordingStatus.LOADING;
  const playback = () => currentPreviewStatus = PreviewStatus.PLAY;
  const pause = () => currentPreviewStatus = PreviewStatus.PAUSE;
  const reRecording = () => {
    currentRecordingStatus = RecordingStatus.BEFORE_RECORDING;
    currentPreviewStatus = PreviewStatus.PAUSE;
    rawBlob = null;
    textArea.value = null;
  }

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  const recorded = async (event) => {
    rawBlob = event.detail.blob;
    const blobDataBase64 = await fileToBase64(rawBlob)
    textArea.value = blobDataBase64;

    playLabel = getTimerLabel(event.detail.duration);
    currentRecordingStatus = RecordingStatus.RECORDED;
  }

  const playerTimeLabel = (time) => playLabel = getTimerLabel(time*1000);
</script>

<div class="fixed top-0 right-0 bottom-0 left-0 flex flex-col bg-[#1A1E2B]">

  <PermitMic />

  <div class="pt-11 pb-14 text-center">
    <span class={`text-white text-sm font-bold ${currentRecordingStatus === RecordingStatus.RECORDED ? 'visible' : 'invisible' }`}>{playLabel}</span>
  </div>
  <Wave
    {currentRecordingStatus}
    {currentPreviewStatus}
    on:recorded={recorded}
    on:pause={pause}
    onTimeUpdate={playerTimeLabel}
  />
  <BottomActions
    {currentRecordingStatus}
    {currentPreviewStatus}
    on:startRecording={startRecording}
    on:stopRecording={stopRecording}
    on:playback={playback}
    on:pause={pause}
    on:reRecording={reRecording}
  />
</div>
